// @flow

import simpleStrategy from '../simple-strategy';
import complexStrategy from '../complex-strategy';

const getStrategyFunctionByType = (type: string): Function => {
  switch (type) {
    case 'simple':
      return simpleStrategy;
    case 'complex':
      return complexStrategy;
    default:
      return () => true;
  }
};

export default getStrategyFunctionByType;
